import { render, staticRenderFns } from "./exhibition-car-no.vue?vue&type=template&id=67ed3d04&scoped=true&"
import script from "./exhibition-car-no.vue?vue&type=script&lang=js&"
export * from "./exhibition-car-no.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-car-no.vue?vue&type=style&index=0&id=67ed3d04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ed3d04",
  null
  
)

export default component.exports